// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"FindCauses_wrapper__1rc_e","inner":"FindCauses_inner__J8OtR","title":"FindCauses_title__ikeQ_"};